import { PageHeader } from '@/components/v2/page-header';
import { BackButton } from '@/components/v2/page-header/page-header-buttons';
import { PageTitle } from '@/components/v2/page-title';
import { v2 } from '@/lib/i18n/v2';
import pendingStyles from '@/components/v2/page-template-pending.module.less';

const Block = ({ style }: { style?: React.CSSProperties }) => (
  <div className={pendingStyles.block} style={style} aria-hidden="true" />
);

/**
 * Feature-requests list pending shape, rendered from the route DEF while the
 * list page chunk downloads (first visit). Like the market intro: the constant
 * chrome (header + title) renders with its real strings so nothing swaps text
 * or shifts layout when the loaded page takes over — only the alpha card and
 * the wish cards skeleton. Eager-safe (DEF-file import): PageHeader family,
 * PageTitle, the strings module and the shared pending CSS module only — no
 * boneyard, hooks, or lazy-chunk imports.
 */
export function FeatureRequestListPending() {
  return (
    <div className={pendingStyles.page} aria-busy="true">
      <PageHeader leftAction={<BackButton onClick={() => undefined} />} />
      <PageTitle title={v2.featureRequestsPage.title} subtitle={v2.featureRequestsPage.subtitle} />
      <div className={pendingStyles.content}>
        {/* Alpha card stub. */}
        <Block style={{ height: 96, marginTop: 16 }} />
        {/* Filter/sort bar stub. */}
        <Block style={{ height: 36, marginTop: 20, borderRadius: 999 }} />
        {/* Wish-card stubs (67px matches the loaded list's fallback geometry). */}
        <Block style={{ height: 67, marginTop: 20, borderRadius: 15 }} />
        <Block style={{ height: 67, marginTop: 8, borderRadius: 15 }} />
        <Block style={{ height: 67, marginTop: 8, borderRadius: 15 }} />
        <Block style={{ height: 67, marginTop: 8, borderRadius: 15 }} />
      </div>
    </div>
  );
}
